import React, { useState, useCallback } from 'react';
import { Tabs, Badge } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { replace as _replace } from 'lodash';
import StorageTab from './components/storageTab';
import MovesGrid from './components/movesGrid';
import InvoicesJournal from './components/invoicesJournal';
import MyMaterials from './components/myMaterials';
import ReferenceTab from './components/referenceTab';

const Materials = () => {
  const [dataVersion, setDataVersion] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);

  const refreshData = useCallback(() => {
    setDataVersion((v) => v + 1);
  }, []);

  const items = [
    {
      key: 'storage',
      label: 'Хранение',
      children: <StorageTab dataVersion={dataVersion} onDataChange={refreshData} />,
    },
    {
      key: 'reference',
      label: 'Справочники',
      children: <ReferenceTab dataVersion={dataVersion} onDataChange={refreshData} />,
    },
    {
      key: 'journal',
      label: 'Журнал',
      children: (
        <MovesGrid dataVersion={dataVersion} onDataChange={refreshData} />
      ),
    },
    {
      key: 'invoices',
      label: 'Накладные',
      children: <InvoicesJournal dataVersion={dataVersion} />,
    },
    {
      key: 'my',
      label: (
        <span>
          Мои материалы
          {pendingCount > 0 && (
            <Badge count={pendingCount} offset={[8, -2]} size="small" />
          )}
        </span>
      ),
      children: (
        <MyMaterials
          dataVersion={dataVersion}
          onDataChange={refreshData}
          onPendingCountChange={setPendingCount}
        />
      ),
    },
  ];

  return (
    <React.Fragment>
      <PageHeader
        title="Материалы"
        style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}
      />
      <Tabs defaultActiveKey="storage" items={items} />
    </React.Fragment>
  );
};

export default Materials;
